<template>
  <div>
    <h2>Gráfico de linhas</h2>
    <form action="" class="md-layout" @submit.prevent="submit">
      <md-field :class="getValidationClass('label')">
        <label for="titulo">Título</label>
        <md-input id="titulo" v-model="label" />
        <span v-if="$v.label" class="md-error">Título obrigatório</span>
      </md-field>
      <md-field :class="getValidationClass('periodoInicial')">
        <label for="periodoInicial">Período</label>
        <md-input
          id="periodoInicial"
          v-model="periodoInicial"
          v-mask="'##:##'"
        />
        <span v-if="$v.periodoInicial" class="md-error"
          >Período obrigatório</span
        >
      </md-field>
      <md-field :class="getValidationClass('altura')">
        <label for="altura">Altura</label>
        <md-input id="altura" v-model.number="altura" type="number" />
        <span v-if="$v.altura" class="md-error">Altura obrigatória</span>
      </md-field>
      <md-field :class="getValidationClass('largura')">
        <label for="largura">Largura</label>
        <md-input id="largura" v-model.number="largura" type="number" />
        <span v-if="$v.largura" class="md-error">Largura obrigatória</span>
      </md-field>

      <div class="md-layout md-alignment-center-left md-gutter">
        <sensor-autocomplete
          id="sensores"
          v-model="sensorIdToAdd"
          class="md-layout-item md-size-75"
          name="sensores"
          :local-id="localId"
        />
        <div class="md-layout-item">
          <md-button class="md-primary md-raised" @click="adicionaSensor">
            Adicionar
          </md-button>
        </div>
      </div>
      <md-table class="unlimited">
        <md-table-row>
          <md-table-head>Sensores</md-table-head>
          <md-table-head />
        </md-table-row>
        <md-table-row
          v-for="sensor in sensores"
          :key="sensor.id"
          class="pt-2 pb-2"
        >
          <md-table-cell>
            <div>
              <span
                >{{ sensor.equipamentoCampoNome }} -
                {{ sensor.descricao }}</span
              >
            </div>
          </md-table-cell>
          <md-table-cell class="md-toolbar-section-end">
            <md-button
              class="md-raised md-accent"
              @click="() => removeSensor(sensor.id)"
            >
              Remover
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>

      <div class="md-layout md-alignment-center-left md-gutter">
        <sensor-virtual-autocomplete
          id="sensorVirtualId"
          v-model="sensorVirtualIdToAdd"
          class="md-layout-item md-size-75"
          name="sensorVirtualId"
          :local-id="localId"
          :should-filter-out-sensor-virtual-fn="shouldFilterOutSensorVirtualFn"
        />
        <div class="md-layout-item">
          <md-button
            class="md-primary md-raised"
            @click="adicionaSensorVirtual"
          >
            Adicionar
          </md-button>
        </div>
      </div>
      <md-table class="unlimited">
        <md-table-row>
          <md-table-head>Sensores Virtuais</md-table-head>
          <md-table-head />
        </md-table-row>
        <md-table-row
          v-for="sensor in sensoresVirtuais"
          :key="sensor.id"
          class="pt-2 pb-2"
        >
          <md-table-cell>
            <div>
              <span
                >{{ sensor.titulo }} - {{ sensor.sensorIndentificador }}</span
              >
            </div>
          </md-table-cell>
          <md-table-cell class="md-toolbar-section-end">
            <md-button
              class="md-raised md-accent"
              @click="() => removeSensorVirtual(sensor.id)"
            >
              Remover
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>

      <div style="text-align: right; width: 100%" class="mt-5">
        <md-button class="md-raised md-accent" @click="() => $emit('close')">
          Cancelar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          {{ isEdit ? 'Editar' : 'Cadastrar' }}
        </md-button>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { EventBus, Topics, Types } from '@/event-bus'
import querySensoresVirtuaisMixin from '@/mixins/query.mixin'
import { ComponenteTipo } from '@/utils/componente'
import http from '@/utils/http'

import SensorAutocomplete from '../../autocomplete/SensorAutocomplete.vue'
import SensorVirtualAutocomplete from '../../autocomplete/SensorVirtualAutocomplete.vue'

export default {
  name: 'ViewTimeSeriesForm',
  components: { SensorAutocomplete, SensorVirtualAutocomplete },
  mixins: [validationMixin, querySensoresVirtuaisMixin],
  props: {
    localId: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      label: '',
      equipamentos: [],
      sensorIdToAdd: null,
      sensoresIds: [],
      sensoresVirtuaisIds: [],
      // Sensores selecionados
      sensores: [],
      // Sensor da cidade
      sensoresCidade: [],
      periodoInicial: '01:00',
      altura: 100,
      largura: 200,
      sensorVirtualIdToAdd: null,
      sensoresVirtuais: [],
    }
  },
  validations: {
    label: { required },
    periodoInicial: { required },
    altura: { required },
    largura: { required },
  },
  computed: {
    isEdit() {
      return this.componente !== null
    },
  },
  async beforeMount() {
    if (this.componente !== null) {
      this.label = this.componente.value.label
      this.sensoresIds = this.componente.value.sensoresIds
      this.periodoInicial = this.componente.value.periodoInicial
      this.altura = this.componente.value.altura
      this.largura = this.componente.value.largura
      this.sensoresVirtuaisIds = this.componente.value.sensoresVirtuaisIds
    }

    const promise1 = http.get(`local/${this.localId}/sensores`).then((e) => {
      this.sensoresCidade = e.sensores
    })

    const promise2 = http
      .get(`local/${this.localId}/equipamentos`)
      .then((e) => {
        this.equipamentos = e.equipamentos
      })

    await Promise.all([promise1, promise2])

    // filter(Boolean): um id salvo pode nao ter correspondente carregado (sensor
    // removido, ou a busca falhou). Sem isso a tabela recebe undefined e o render
    // quebra ao ler .id/.titulo.
    this.sensores = this.sensoresIds
      .map((e) =>
        this.sensoresCidade.find((sensorCidade) => sensorCidade.id === e)
      )
      .filter(Boolean)

    const sensoresVirtuais = Object.values(
      await this.loadSensoresVirtuais()
    ).flatMap((e) => e.sensoresVirtuais)

    this.sensoresVirtuais = this.sensoresVirtuaisIds
      .map((e) =>
        sensoresVirtuais.find((sensorVirtual) => sensorVirtual.id === e)
      )
      .filter(Boolean)
  },
  methods: {
    shouldFilterOutSensorVirtualFn(sensorVirtual) {
      return !sensorVirtual.persistencia
    },
    adicionaSensor() {
      const sensor = this.sensoresCidade.find(
        (e) => e.id === this.sensorIdToAdd
      )

      if (sensor == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Sensor não encontrado',
        })
        return
      }

      if (this.sensoresIds.some((e) => e === this.sensorIdToAdd)) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Sensor já adicionado',
        })
        return
      }

      this.sensoresIds.push(this.sensorIdToAdd)
      this.sensorIdToAdd = null
      this.sensores.push(sensor)
    },
    adicionaSensorVirtual() {
      if (this.sensorVirtualIdToAdd == null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um sensor virtual',
        })
        return
      }

      if (
        this.sensoresVirtuaisIds.some((e) => e === this.sensorVirtualIdToAdd)
      ) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Sensor Virtual já adicionado',
        })
        return
      }

      const sensorVirtual = Object.values(this.equipamentosComSensoresVirtuais)
        .flatMap((e) => e.sensoresVirtuais)
        .find((e) => e.id === this.sensorVirtualIdToAdd)

      this.sensoresVirtuaisIds.push(this.sensorVirtualIdToAdd)
      this.sensorVirtualIdToAdd = null
      this.sensoresVirtuais.push(sensorVirtual)
    },
    removeSensor(sensorId) {
      this.sensoresIds = this.sensoresIds.filter((e) => e !== sensorId)
      this.sensores = this.sensores.filter((e) => e.id !== sensorId)
    },
    removeSensorVirtual(sensorId) {
      this.sensoresVirtuaisIds = this.sensoresVirtuaisIds.filter(
        (e) => e !== sensorId
      )
      this.sensoresVirtuais = this.sensoresVirtuais.filter(
        (e) => e.id !== sensorId
      )
    },
    async submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      let response

      const value = {
        label: this.label,
        sensoresIds: this.sensoresIds,
        periodoInicial: this.periodoInicial,
        altura: this.altura,
        largura: this.largura,
        sensoresVirtuaisIds: this.sensoresVirtuaisIds,
      }

      if (this.isEdit) {
        response = await http.put(`/view/componente`, {
          id: this.componente.id,
          value: value,
          z: this.componente.z,
        })
      } else {
        response = await http.post(`/view/componente`, {
          tipo: ComponenteTipo.TimeSeriesView,
          viewId: this.viewId,
          value: value,
        })
      }

      if (response) {
        this.$emit('close')
        this.$emit('updated')
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.unlimited {
  padding: 0;
  margin: 0;
  width: 100%;
}
</style>
